// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--jewWA","icon":"a10a3f92e9--icon--kyouV","icon--inner":"a10a3f92e9--icon--inner--XHgIW","tooltip":"a10a3f92e9--tooltip--PM2Wm"};